import alertIcon from "../assets/images/icons/alert-icon.svg";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useContext} from "react";
import {MainContext} from "../utils/MainContext";
import {LoginContext} from "../utils/Auth";

const CompleteRegisterNotificationCard = () => {
    const {t} = useTranslation();
    const {setStep} = useContext(MainContext);
    const {user} = useContext(LoginContext);

    return (
        <div
            className="completeRegisterNotificationCard"
            style={{
                display: user?.phone_number !== null ? "none" : "flex",
            }}
        >
            <div className="overlay"></div>
            <div className="notify">
                <div className="alertArea">
                    <div className="alertIcon">
                        <img src={alertIcon} alt="alert-icon"/>
                    </div>
                    <p className="alertInfo">
                        {t("completeRegisterNotificationCard.alertInfo")}
                    </p>
                </div>
                <Link
                    className="alertCardBtn"
                    to="/register"
                    onClick={() => setStep(3)}
                >
                    {t("completeRegisterNotificationCard.submit")}
                </Link>
            </div>
        </div>
    );
};

export default CompleteRegisterNotificationCard;
